import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { Paragraph, h2 } from "@/styles/typography";

const Inner = styled(MainInner)`
  align-items: center;
`;

const TextWrapper = styled.div<{ $position: string }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: ${({ $position }) => $position};
  align-items: ${({ $position }) =>
    $position === "left" ? "flex-start" : "center"};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 32px;
  }
`;

const Title = styled(h2)<{ $position: string }>`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: ${({ $position }) => ($position === "left" ? "100%" : "70%")};
  }
`;

const Text = styled(Paragraph)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 70%;
  }
`;

const LinkWrapper = styled.div``;

const S = {
  Inner,
  Title,
  TextWrapper,
  Text,
  LinkWrapper,
};

export default S;
